import styled from 'styled-components';

export const Label = styled.div`
  font-weight: 600;
`;
